import { Skeleton } from "@material-ui/lab";
import { makeStyles } from "@material-ui/styles";
import * as React from "react";

import { narrowMediaQuery } from "../scheduling-link/scheduling-link.styles";

export interface SchedulingLinkLoadingProps {}

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "flex-start",
    gap: 100,
    maxWidth: 800,
    minWidth: 700,
    margin: "50px 70px",
  },
  meetingDetails: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 40,
  },
  titleAndName: {},
  duration: {
    borderRadius: 30,
    marginBottom: 55,
  },
  calendar: {
    borderRadius: 10,
  },
  right: {
    width: 400,
    display: "flex",
    gap: 33,
    marginTop: 43,

    [narrowMediaQuery]: {
      display: "none",
    },
  },
  times: {
    display: "flex",
    gap: 15,
    flexDirection: "column",

    "& > span": {
      borderRadius: 10,
    },
  },
  header: {
    marginBottom: 10,
  },
});

export const SchedulingLinkLoading = ({}: SchedulingLinkLoadingProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container} role="progressbar">
      <div>
        <div className={classes.meetingDetails}>
          <Skeleton variant="circle" width={80} height={80} />
          <div className={classes.titleAndName}>
            <Skeleton variant="text" width={200} height={50} />
            <Skeleton variant="text" width={200} height={50} />
          </div>
        </div>
        <Skeleton className={classes.duration} variant="rect" width={135} height={35} />
        <Skeleton className={classes.calendar} variant="rect" width={300} height={350} />
      </div>
      <div className={classes.right}>
        <div>
          <Skeleton className={classes.header} variant="text" width={160} height={70} />
          <div className={classes.times}>
            <Skeleton variant="rect" width={225} height={85} />
            <Skeleton variant="rect" width={225} height={85} />
            <Skeleton variant="rect" width={225} height={85} />
          </div>
        </div>
        <div>
          <Skeleton className={classes.header} variant="text" width={160} height={70} />
          <div className={classes.times}>
            <Skeleton variant="rect" width={225} height={85} />
            <Skeleton variant="rect" width={225} height={85} />
          </div>
        </div>
      </div>
    </div>
  );
};
